import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { formatDate, getRecords } from "../../services/api.service";
import { exportPageData } from "./CommissioningListFile";
import moment from "moment";

const breadcrumbItems = [];

const CommissioningListList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    getData(projectId, contractor_id);
  }, [searchKeyword, page, pageSize]);
  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    handleExportData(projectId, contractor_id);
  }, []);
  const getData = async (Id, contractor_id) => {
    try {
      const payload = {
        modelName: "commissionings",
        modifyResponse: true,
        getCommissioningDetails: true,
        listInstallation: true,
        whereCondition: {
          project_id: Id,
        },
        relations: [
          {
            module: "installations",
            moduleAs: "installation",
          },
          {
            module: "user_masters",
            moduleAs: "creator",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "commissioningForm",
          },
        ],
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
        search: {
          field_name: ["commissioning_no", "creator.first_name"],
          searchKeyword: searchKeyword,
        },
      };

      const responseData = await getRecords(payload, "/listCommissioning");

      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });

      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/outward-create");
  };

  const handleViewClick = (id) => {
    navigate(`/commissioninglist-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "COMISSIONING NO",
        accessor: (row) =>
          row?.commissioning_no && row?.commissioning_no
            ? row?.commissioning_no
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "COMISSIONING PERSON",
        accessor: (row) =>
          row?.creator
            ? row?.creator.first_name + " " + row?.creator.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "COMMISSIONING DATE",
        accessor: (row) =>
          row?.updatedAt && row?.updatedAt ? row?.updatedAt : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "150px" }}>{formatDate(value)}</div>
        ),
      },
      {
        Header: "COMMISSIONING STATUS",
        accessor: (row) => row?.installation?.status || "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => {
          const installation = row?.original?.installation;

          let text = "-";
          let badgeClass = "text-secondary";

          if (installation?.is_commissioning_paid) {
            text = "Commissioning Paid";
            badgeClass = "bg-success-subtle text-success";
          } else if (installation?.is_commissioning_claimed) {
            text = "Commissioning Claimed";
            badgeClass = "bg-primary-subtle text-primary";
          } else if (installation?.status === "commissioning_completed") {
            text = "Commissioning Completed";
            badgeClass = "bg-info-subtle text-info";
          } else {
            text = "Commissioning Created";
            badgeClass = "bg-warning-subtle text-warning";
          }

          return (
            <div style={{ width: "150px" }}>
              <span className={`badge ${badgeClass} text-uppercase`}>
                {text}
              </span>
            </div>
          );
        },
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px" }}>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const handleExportData = async (projectId, contractor_id) => {
    try {
      const payload = {
        modelName: "commissionings",
        modifyResponse: true,
        getCommissioningDetails: true,
        listInstallation: true,
        whereCondition: {
          project_id: projectId,
        },
        relations: [
          {
            module: "installations",
            moduleAs: "installation",
          },
          {
            module: "user_masters",
            moduleAs: "creator",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "commissioningForm",
          },
        ],

        pagination: { page: 1, pageSize: 100000 },
      };

      const responseData = await getRecords(payload, "/listCommissioning");
      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,

        "COMMISSIONING NO": item?.commissioning_no || "N/A",
        "COMMISSIONING PERSON":
          item?.creator.first_name + " " + item?.creator.last_name || "N/A",
        "COMMISSIONING DATE": formatDate(item?.createdAt) || "N/A",

        "COMMISSIONING STATUS": (() => {
          const installation = item?.installation;

          if (installation?.is_commissioning_paid) {
            return "Commissioning Paid";
          } else if (installation?.is_commissioning_claimed) {
            return "Commissioning Claimed";
          } else if (installation?.status === "commissioning_completed") {
            return "Commissioning Completed";
          } else {
            return "N/A";
          }
        })(),

        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Commissioning List"
              breadcrumbItems={breadcrumbItems}
            />
            {/* <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Outward
            </Button> */}
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CommissioningListList;
